// extracted by mini-css-extract-plugin
export default {"modal-sheet":"ModalSheet_modal-sheet__TC3XD","active":"ModalSheet_active__B-KiF"};